export default {
  'selected'(state) {
    return state.ui.compare.selected
  },
  'recentTerms'(state) {
    return state.ui.search ? state.ui.search.recent : []
  }
}
